import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

import Context from "shared/util/Context";
import getImagePath from "shared/util/getImagePath";
import { isMobile } from "shared/util/EnvironmentHelpers";
import { META_CONTENT } from "../util/consts";
import {
	getPageTitle,
} from "routers/shared/util/helpers";

const RESPONSIVE_DESKTOP = [
];

const NO_BANNER = [
	"/doubletake",
	"/home",
	"/",
];

const UniversalHead = ({
	location,
}) => {
	const isLoggedIn = Context.get("userid");
	const imagePath = getImagePath();
	const isResponsive = isMobile || RESPONSIVE_DESKTOP.includes(location.pathname);
	const showBanner = isMobile && isLoggedIn && NO_BANNER.includes(location.pathname);
	const pageTitle = `${getPageTitle(location)} | OkCupid`;

	return (
		<Helmet>
			<title>{pageTitle}</title>

			<meta name="description" content={META_CONTENT.description} />

			<meta property="fb:app_id" content="153408784666" />
			<meta property="og:site_name" content={META_CONTENT.siteName} />
			<meta property="og:type" content="website" />
			<meta property="og:title" content={pageTitle} />
			<meta property="og:description" content={META_CONTENT.description} />
			<meta property="og:image" content={`${imagePath}${META_CONTENT.thumbPath}`} />

			<meta name="twitter:card" content="summary" />
			<meta name="twitter:domain" content={window.location.host.replace("www.", "")} />
			<meta name="twitter:site" content="@okcupid" />
			<meta name="twitter:creator" content="OkCupid" />
			<meta name="twitter:title" content={pageTitle} />
			<meta name="twitter:description" content={META_CONTENT.description} />
			<meta name="twitter:image:src" content={`${imagePath}${META_CONTENT.thumbPath}`} />

			<meta itemProp="name" content={pageTitle} />
			<meta itemProp="description" content={META_CONTENT.description} />
			<meta itemProp="image" content={`${imagePath}${META_CONTENT.thumbPath}`} />

			<meta name="pinterest" content="nopin" />

			<link rel="apple-touch-icon" href={`${imagePath}media/img/logos/2019/48.png`} sizes="48x48" />
			<link rel="apple-touch-icon" href={`${imagePath}media/img/logos/2019/72.png`} sizes="72x72" />
			<link rel="apple-touch-icon" href={`${imagePath}media/img/logos/2019/114.png`} sizes="114x114" />
			<link rel="apple-touch-icon" href={`${imagePath}media/img/logos/2019/144.png`} sizes="144x144" />
			<link rel="apple-touch-icon" href={`${imagePath}media/img/logos/2019/400.png`} sizes="400x400" />

			{isResponsive && (
				<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
			)}

			{showBanner && (
				<meta name="apple-itunes-app" content="app-id=338701294, app-argument=okcupid://home?redirect_from=smartbanner" />
			)}
		</Helmet>
	);
};

UniversalHead.propTypes = {
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
	}).isRequired,
};

export default UniversalHead;



// WEBPACK FOOTER //
// ./src/routers/shared/components/UniversalHead.jsx